import type { Options } from "sortablejs";
// eslint-disable-next-line import-x/no-named-as-default -- false positive
import Sortable from "sortablejs";
import type { Ref } from "vue";
import { onUnmounted, watch } from "vue";

/**
 * Attaches a SortableJS instance to the element held by `elementRef`, and
 * re-attaches whenever the element changes (e.g. when a panel's content is
 * mounted via `v-if`). The instance is destroyed when the element goes away
 * and when the consuming component unmounts.
 */
export function useSortable(elementRef: Ref<HTMLElement | null>, options: Options) {
  let sortable: Sortable | null = null;

  watch(
    elementRef,
    (el) => {
      sortable?.destroy();
      sortable = el ? Sortable.create(el, options) : null;
    },
    { immediate: true },
  );

  onUnmounted(() => {
    sortable?.destroy();
    sortable = null;
  });
}
